import { DEMO_MODE } from '../config';

/**
 * サムネイルのURLを生成する関数
 * @param thumbnailPath データベースに保存されているサムネイルパス（例: "uploads/Thumbnail/filename.jpg"）
 * @returns 正しいサムネイルAPIエンドポイントのURL
 */
export const getThumbnailUrl = (thumbnailPath: string | null | undefined): string | null => {
  if (!thumbnailPath) {
    return null;
  }

  // blob: / http: / https: などの完全URLはそのまま返す
  if (/^(blob:|https?:)/.test(thumbnailPath)) {
    return thumbnailPath;
  }

  // デモモードでは public 配下のルート相対パス（例: /demo/thumb-1.jpg）をそのまま使う
  if (DEMO_MODE && thumbnailPath.startsWith('/')) {
    return thumbnailPath;
  }

  // パスからファイル名を抽出
  const filename = thumbnailPath.split('/').pop();

  if (!filename) {
    return null;
  }

  // 正しいAPIエンドポイントを使用
  return `/api/videos/thumbnail/${filename}`;
};

/**
 * デフォルトのサムネイル画像URLを取得する関数
 * @returns デフォルトサムネイル画像のURL
 */
export const getDefaultThumbnailUrl = (): string => {
  // パブリックディレクトリから直接読み込み
  return '/images/default_thumbnail.svg';
};

/**
 * スピナー表示可否の判定に使う、動画の最小限の情報
 */
export interface ThumbnailPendingVideo {
  is_processing?: boolean;
  conversion_status?: 'pending' | 'converting' | 'completed' | 'failed';
}

/**
 * サムネイルが未設定のカードで、スピナーを出すべきか（＝変換の順番待ち/変換中か）を判定する関数
 * - アップロードセッション由来の仮カード（is_processing）は常にスピナー対象
 * - conversion_status が pending / converting の間はスピナー対象
 * - completed / failed、またはフィールド自体が無い（外部動画・旧データ等）場合はスピナー対象外
 *   （呼び出し側は既定のサムネイル画像を出す）
 * @param video is_processing・conversion_status を持つ動画データ
 * @returns スピナーを表示すべきなら true
 */
export const isThumbnailPending = (video: ThumbnailPendingVideo): boolean => {
  if (video.is_processing) {
    return true;
  }
  return video.conversion_status === 'pending' || video.conversion_status === 'converting';
};

